import pieChartScanValidity from './pieChartScanValidity.container';

export default pieChartScanValidity;
